import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { LedgerAccount } from './LedgerAccount.entity';

export class TenantBankAccount<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: name */
  name?: string;
  /** Alias: accountOwner */
  accountOwner?: string;
  /** Alias: mainAccount */
  mainAccount?: boolean;
  /** Alias: iBAN */
  iban?: string;
  /** Alias: bIC */
  bic?: string;
  /** Alias: sEPACreditorId */
  sEPACreditorId?: string;
  /** Alias: ledgerAccount */
  ledgerAccount?: LedgerAccount<T>;
  /** Alias: ledgerAccountCode */
  ledgerAccountId?: number;

  __typename?: string;
}

const fields: FieldDefinitions<TenantBankAccount> = {
  id: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  accountOwner: {
    alias: 'accountOwner',
  },
  mainAccount: {
    alias: 'mainAccount',
  },
  iban: {
    alias: 'iBAN',
  },
  bic: {
    alias: 'bIC',
  },
  sEPACreditorId: {
    alias: 'sEPACreditorId',
  },
  ledgerAccount: {
    alias: 'ledgerAccount',
    entity: Entities.ledgerAccount,
  },
  ledgerAccountId: {
    alias: 'ledgerAccountCode',
  },
  __typename: {
    alias: '__typename',
  },
};

export const tenantBankAccountEntityDefinition: EntitiyDefinition<TenantBankAccount> =
  {
    local: {},
    remote: {
      queryName: 'getTenantBankAccounts',
      fragmentName: 'TenantBankAccount',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'upsertTenantBankAccount',
          args: [
            { name: 'input', type: 'InputTenantBankAccount!' },
            { name: 'drySave', type: 'Boolean' },
          ],
        },
      },
    },
    fieldDefinitions: fields,
  };
